import { render, staticRenderFns } from "./regulation1.vue?vue&type=template&id=a1f285e6&scoped=true"
import script from "./regulation1.vue?vue&type=script&lang=js"
export * from "./regulation1.vue?vue&type=script&lang=js"
import style0 from "./regulation1.vue?vue&type=style&index=0&id=a1f285e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f285e6",
  null
  
)

export default component.exports